import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BlDetails, ClientesBl, OperationType, TableConfig } from 'src/app/interfaces/bl.interfaces';
import { BlService } from 'src/app/_services/bl/bl.service';
import { LoteService } from 'src/app/_services/lote/lote.service';
import { DeleteLote, GetLote } from 'src/app/interfaces/lotes.interfaces';
import { LoteCabotajeService } from 'src/app/_services/loteCabotaje/lote-cabotaje.service';
import { AuthService } from 'src/app/_services/auth/auth.service';
interface infoLote {
  operationNumber:  string;
  id:               number;
}
@Component({
  selector: 'app-bl-detalle',
  templateUrl: './bl-detalle.component.html',
  styleUrls: ['./bl-detalle.component.css']
})
/**
 * Página de detalle de un BL/barco.
 *
 * Carga los datos del barco, sus clientes y lotes según el tipo de operación
 * (importación, exportación, cabotaje), configura la tabla de lotes y permite
 * crear, eliminar lotes, cargar lotes desde Excel y saldar el barco a ceros.
 */
export class BlDetalleComponent implements OnInit {
  blDetails: BlDetails = {
    operation_number:     0,
    boats_name:           '',
    operation_type_number:0,
    bl_tonnage:           0,
    customer_name:        null,
    date_time_capture:    '',
    dock_name:            '',
    port_origin_name:     '',
    start_operations:     '',
    end_operations:       '',
    boat_nationality:     '',
    destination_port:     '',
    operation_id:         0,
    docking_date:         '',
    undocking_date:       '',
    bl_master:            '',
    notice_of_readiness:  '',
    remaining_tonnage:    0,
    output_total_tonnage: 0,
    operation_type:       '',
  };
  operation_number: number = 0;
  clientesBl: ClientesBl[] = [];
  buttonText: string = 'Guardar';
  loader: boolean = false;
  loteEliminar: boolean = false;
  errorOverlay: boolean = false;
  loading: boolean = false;
  icono: string = '';
  mensaje: string = '';
  infoLote: infoLote = {
    operationNumber: '',
    id: 0,
  };
  table_config: TableConfig = {
    tableHeads: [
      ['BL lote', 'bl_lot_id'],
      ['Cliente', 'client_name'],
      ['Material', 'material_group_name'],
      ['Piezas', 'quantity_pieces'],
      ['Toneladas de entrada', 'input_tons'],
      ['Toneladas de salida', 'output_tons'],
      ['Toneladas restantes', 'remaining_tons'],
      ['Status SIRA VUCEM', 'batch_status'],
      ['Estatus Pedimento', 'rectification'],
    ],
    tableHeadsContainer: ['Entradas/ Salidas', 'Detalle', 'Editar', 'Eliminar'],
    styles: {
      table_heads: {
        'grid-template-columns': 'repeat(7, minmax(90px, 1fr)) repeat(2, minmax(90px, 1fr)) 250px',
        'min-width': '1060px',
        'margin': '0',
        'padding': '0',
      },
      table_row: {
        'grid-template-columns': 'repeat(7, minmax(90px, 1fr)) repeat(2, minmax(90px, 1fr)) 250px',
        'min-width': '1060px',
      },
      table_row_totals: {
        'grid-template-columns': 'repeat(7, minmax(90px, 1fr)) repeat(2, minmax(90px, 1fr)) 250px',
        'min-width': '1060px',
        'background-color': '#455660',
        'color': '#fff',
      },
      container_icons: {
        'grid-template-columns': 'repeat(4, 1fr)',
      }
    },
    arrayFields: [
      'bl_lot_id',
      'client_name',
      'material_group_name',
      'quantity_pieces',
      'input_tons',
      'output_tons',
      'remaining_tons',
      'batch_status',
      'rectification'
    ],
    iconos: [["/lote-movimiento/entrada", "registry_number", 'bi bi-arrow-left-right'], ["/lote-detalle", "registry_number", 'bi bi-eye'],["/lote-actualizar", "registry_number", 'bi bi-pencil-square'], ["/lote-eliminar", "registry_number", 'bi bi-trash3']],
    mensaje: "Sin lotes asignados.",
    filter: true,
    totals: {
      show: true,
      content: ['', '', 'Totales:', 'piezas', 'total', 'total_output', 'total_remaining', '', ''],
      total: 0,
      total_output: 0,
      total_remaining: 0,
      piezas: 0
    }
  };
  addLote: boolean = false;
  overlayError: boolean = false;
  isAuthorized: boolean = false;
  isImportationPieces: boolean = false;
  isExportation: boolean = false;
  deleteBatchesOverlay: boolean = false;
  auth: any;
  createBatches: boolean = false;
  deleteBatches: boolean = false;
  updateShipMessage: string = 'Saldar barco a ceros';
  confirmUpdateShip: boolean = false;
  confirmUpdateShipMessage: string = '¿Está seguro de saldar el barco a ceros?';
  updateShipAuthorization: boolean = false;
  keyToSort: 'registry_number' | 'bl_lot_id' = 'registry_number';
  showAfterJan2026: boolean = false;

  get lotesArray() {
    return this.loteService.lotesFilter;
  }

  get boatDetails() {
    return this.blDetails;
  }

  get exportation() {
    return this.loteService.loteExport;
  }

  get cabotageImp() {
    return this.loteService.loteCabotageImp;
  }

  get cabotageExp() {
    return this.loteService.loteCabotageExp;
  }

  constructor(
    private blServices: BlService,
    private loteService: LoteService,
    private loteCabotajeService: LoteCabotajeService,
    private activatedRoute: ActivatedRoute,
		private authService: AuthService,
		private router: Router,
  ) { }

  ngOnInit(): void {
    // Set the path for the arrow back icon
    this.blServices.path = '/ship-list';
    this.loading = true;
    this.auth = this.authService.getAuthorizationsByModule('import');
    const boatAuthorizations = this.authService.getAuthorizationsByModule('boat_list');
    this.createBatches = this.authService.hasAuthorization('import', 'actions', 'create');
    this.deleteBatches = this.authService.hasAuthorization('import', 'actions', 'delete');
    if (boatAuthorizations && boatAuthorizations.actions && boatAuthorizations.actions.update && typeof boatAuthorizations.actions.update === 'boolean')
      this.updateShipAuthorization = boatAuthorizations.actions.update
    this.blServices.bls = [];
    this.blServices.blsFilter = [];
    this.loader = true;
    this.operation_number = Number(this.activatedRoute.snapshot.paramMap.get('shipId'));
    this.table_config.iconos = [
      [`/ship-list/${this.operation_number}/importation/batch-movement/entry`, "registry_number", 'bi bi-arrow-left-right'],
      [`/ship-list/${this.operation_number}/importation/batch-detail`, "registry_number", 'bi bi-eye'],
      [`/ship-list/${this.operation_number}/importation/batch-update`, "registry_number", 'bi bi-pencil-square'],
      ["/lote-eliminar", "registry_number", 'bi bi-trash3']
    ];
    // 14: Fertilizante and 24: Supersacos
    const materialsForDisplayingObservations = [14, 24];
    // Get ship details
    this.blServices.getBlId(this.operation_number)
    .subscribe({
      next: (blDetails) => {
        if (!Array.isArray(blDetails) || !blDetails.length) {
          this.loader = false;
          this.loading = false;
          this.overlayError = true;
          return;
        }
        this.blDetails = blDetails[0];
        this.updateShipBalanceText();
        // Validar si la fecha notice_of_readiness o docking_date del barco es mayor o igual al 1 de enero de 2026
        const targetDate = new Date('2026-01-01');
        const shipDate = this.blDetails.notice_of_readiness || this.blDetails.docking_date;
        this.showAfterJan2026 = shipDate ? new Date(shipDate) >= targetDate : false;
        this.isExportation = this.blDetails.operation_type_number === OperationType.Exportation;
        // Get clients associated with the ship
        this.blServices.getClientesBl(this.blDetails.operation_id)
        .subscribe({
          next: clientesBl => {
            clientesBl.forEach( (cliente, index) => {
              cliente.id = index + 1;
            });
            this.clientesBl = [...clientesBl];
            this.checkImportationPieces();
          },
          error: (e) => {
            this.showError('Error en el servidor al cargar la informacion de los clientes, inténtelo más tarde', 3000);
          }
        });
        if (this.blDetails.operation_type_number === OperationType.Importation) {
          this.loteService.loteExport = false;
          this.loteService.loteCabotageImp = false;
          this.loteService.loteCabotageExp = false;
          // Get batches associated with the iportation ship
          this.loteService.getLotesBl(this.blDetails.operation_id)
          .subscribe({
            next: lotes => {
              if (!lotes.length) {
                this.loteService.lotes = [];
                this.loteService.lotesFilter = [];
                this.loading = false;
                this.loader = false;
                return;
              }
              lotes = lotes.map( lote => (
                {
                  ...lote,
                  location_name: lote.location_name ? lote.location_name : 'No asignada.',
                  quantity_pieces: lote.quantity_pieces ? lote.quantity_pieces : 0,
                  bl_lot_id: lote.bl_lot_id ? lote.bl_lot_id : 'No asignado.'
                }
              ));
              const hasSupersacosBatch = lotes.some(batch => batch.material_group_id === 24);
              this.keyToSort = hasSupersacosBatch ? 'bl_lot_id' : 'registry_number';
              if (this.loteService.batchListHasTheseMaterials(lotes, materialsForDisplayingObservations)) {
                this.table_config.tableHeads[2] = ['Observaciones', 'observations'];
                this.table_config.arrayFields[2] = 'observations';
              }
              // Ordenar una sola vez al cargar los datos
              if (hasSupersacosBatch) {
                lotes = this.sortArrayDescending(lotes, this.keyToSort);
              } else {
                lotes = this.sortArray(lotes, this.keyToSort);
              }
              this.loteService.lotes = [...lotes];
              this.loteService.lotesFilter = [...lotes];
              this.updateTotals(lotes, true);
              this.loader = false;
              this.loading = false;
            },
            error: (e) => {
              this.showError('Error en el servidor al cargar los lotes, inténtelo más tarde', 3000);
            }
          });
        } else if (this.blDetails.operation_type_number === OperationType.Exportation) {
          this.loteService.loteExport = true;
          this.loteService.loteCabotageImp = false;
          this.loteService.loteCabotageExp = false;
          this.exportConfigTable();
          // Get batches associated with the exportation ship
          this.loteService.assignExportShip(this.blDetails.operation_number)
          .subscribe({
            next: lotes => {
              if (!lotes.length) {
                this.loteService.lotes = [];
                this.loteService.lotesFilter = [];
                this.loading = false;
                this.loader = false;
                return;
              }
              lotes = lotes.map( lote => (
                {
                  ...lote,
                  location_name: lote.location_name ? lote.location_name : 'No asignada.',
                  quantity_pieces: lote.quantity_pieces ? lote.quantity_pieces : 0,
                  bl_lot_id: lote.bl_lot_id ? lote.bl_lot_id : 'No asignado.'
                }
              ));
              const hasSupersacosBatch = lotes.some(batch => batch.material_group_id === 24);
              this.keyToSort = hasSupersacosBatch ? 'bl_lot_id' : 'registry_number';
              if (this.loteService.batchListHasTheseMaterials(lotes, materialsForDisplayingObservations)) {
                this.table_config.tableHeads[2] = ['Observaciones', 'observations'];
                this.table_config.arrayFields[2] = 'observations';
              }
              // Ordenar una sola vez al cargar los datos
              if (hasSupersacosBatch) {
                lotes = this.sortArrayDescending(lotes, this.keyToSort);
              } else {
                lotes = this.sortArray(lotes, this.keyToSort);
              }
              this.loteService.lotes = [...lotes];
              this.loteService.lotesFilter = [...lotes];
              this.updateTotals(lotes, false);
              this.loader = false;
              this.loading = false;
            },
            error: (e) => {
              this.showError('Error en el servidor al cargar los lotes, inténtelo más tarde', 3000);
            },
          });
        } else if (this.blDetails.operation_type_number === OperationType.CabotageImp) {
          this.cabotageConfigTable();
          this.loteService.loteExport = false;
          this.loteService.loteCabotageImp = true;
          this.loteService.loteCabotageExp = false;
          // Get batches associated with the import cabotage ship
          this.loteCabotajeService.getCabotageBatchesByShip(this.blDetails.operation_id)
          .subscribe({
            next: lotes => {
              if (!lotes.length) {
                this.loteService.lotes = [];
                this.loteService.lotesFilter = [];
                this.loading = false;
                this.loader = false;
                return;
              }
              lotes = lotes.map( lote => (
                {
                  ...lote,
                  location_name: lote.location_name ? lote.location_name : 'No asignada.',
                  quantity_pieces: lote.quantity_pieces ? lote.quantity_pieces : 0,
                  bl_lot_id: lote.bl_lot_id ? lote.bl_lot_id : 'No asignado.'
                }
              ));
              const hasSupersacosBatch = lotes.some(batch => batch.material_group_id === 24);
              this.keyToSort = hasSupersacosBatch ? 'bl_lot_id' : 'registry_number';
              if (this.loteService.batchListHasTheseMaterials(lotes, materialsForDisplayingObservations)) {
                this.table_config.tableHeads[2] = ['Observaciones', 'observations'];
                this.table_config.arrayFields[2] = 'observations';
              }
              // Ordenar una sola vez al cargar los datos
              if (hasSupersacosBatch) {
                lotes = this.sortArrayDescending(lotes, this.keyToSort);
              } else {
                lotes = this.sortArray(lotes, this.keyToSort);
              }
              this.loteService.lotes = [...lotes];
              this.loteService.lotesFilter = [...lotes];
              this.updateTotals(lotes, true);
              this.loader = false;
              this.loading = false;
            },
            error: (e) => {
              this.showError('Error en el servidor al cargar los lotes, inténtelo más tarde', 3000);
            },
          });
        } else if (this.blDetails.operation_type_number === OperationType.CabotageExp) {
          this.loteService.loteExport = false;
          this.loteService.loteCabotageImp = false;
          this.loteService.loteCabotageExp = true;
          this.exportConfigTable();
          // Get batches associated with the export cabotage ship
          this.loteCabotajeService.assignCabotageShip(this.blDetails.operation_number)
          .subscribe({
            next: lotes => {
              if (!lotes.length) {
                this.loteService.lotes = [];
                this.loteService.lotesFilter = [];
                this.loading = false;
                this.loader = false;
                return;
              }
              lotes = lotes.map( lote => (
                {
                  ...lote,
                  location_name: lote.location_name ? lote.location_name : 'No asignada.',
                  quantity_pieces: lote.quantity_pieces ? lote.quantity_pieces : 0,
                  bl_lot_id: lote.bl_lot_id ? lote.bl_lot_id : 'No asignado.'
                }
              ));
              const hasSupersacosBatch = lotes.some(batch => batch.material_group_id === 24);
              this.keyToSort = hasSupersacosBatch ? 'bl_lot_id' : 'registry_number';
              if (this.loteService.batchListHasTheseMaterials(lotes, materialsForDisplayingObservations)) {
                this.table_config.tableHeads[2] = ['Observaciones', 'observations'];
                this.table_config.arrayFields[2] = 'observations';
              }
              // Ordenar una sola vez al cargar los datos
              if (hasSupersacosBatch) {
                lotes = this.sortArrayDescending(lotes, this.keyToSort);
              } else {
                lotes = this.sortArray(lotes, this.keyToSort);
              }
              this.loteService.lotes = [...lotes];
              this.loteService.lotesFilter = [...lotes];
              this.updateTotals(lotes, false);
              this.loader = false;
              this.loading = false;
            },
            error: (e) => {
              this.showError('Error en el servidor al cargar los lotes, inténtelo más tarde', 3000);
            },
          });
        }
      },
      error: (e) => {
        this.showError();
      },
    });
  }

  /**
   * Solicita confirmación para eliminar un lote, validando el permiso de borrado.
   * @param infoLote - Información del lote a eliminar (número de operación e id).
   */
  confirm(infoLote: infoLote) {
    if ( this.auth.actions.delete === false ) {
      this.isAuthorized = true;
      setTimeout(() => {
        this.isAuthorized = false;
      }, 3000);
      return;
    }
    this.infoLote = {
      ...infoLote
    }
    this.loteEliminar = true;
  }

  /**
   * Elimina el lote seleccionado (importación o cabotaje) y recarga la lista,
   * o cancela la operación.
   * @param cancelar - Si tiene valor, cancela la eliminación.
   */
  deleteLote( cancelar: string ) {
    if ( cancelar ) {
      this.loteEliminar = false;
      return;
    }
    const loteDelete: DeleteLote = {
      operation_id: Number(this.blDetails.operation_id),
      registry_number: this.infoLote.id
    }
    this.loteEliminar = false;
    this.loader = true;
    this.loading = true;
    if (this.blDetails.operation_type_number === OperationType.Importation) {
      this.loteService.deleteLote(loteDelete)
      .subscribe({
        next: response => {
          if (response.error) {
            this.loading = false;
            this.loader = false;
            this.mensaje = 'No se puede eliminar lotes que tengan una operación registrada';
            this.icono = 'bi bi-exclamation-circle-fill';
            this.errorOverlay = true;
            setTimeout(() => {
              this.errorOverlay = false;
            }, 2000);
            return;
          }
          this.loteService.getLotesBl(this.blDetails.operation_id)
          .subscribe({
            next: lotes => {
              this.loteService.lotes = [...lotes];
              this.loteService.lotesFilter = [...lotes];
              this.updateTotals(lotes, true);
              this.loader = false;
              this.loading = false;
              this.mensaje = 'Lote eliminado correctamente';
              this.icono = 'bi bi-check2';
              this.errorOverlay = true;
              setTimeout(() => {
                this.errorOverlay = false;
              }, 2000);
            },
            error: (e) => {
              this.loader = false;
              this.loading = false;
              this.mensaje = 'Error en el servidor al cargar los lotes, inténtelo más tarde';
              this.icono = 'bi bi-exclamation-circle-fill';
              this.errorOverlay = true;
              setTimeout(() => {
                this.errorOverlay = false;
              }, 3000);
            },
          });
        },
        error: (e) => {
          this.loading = false;
          this.loader = false;
          this.mensaje = 'Error en el servidor al eliminar el registro, inténtelo más tarde';
          this.icono = 'bi bi-exclamation-circle-fill';
          this.errorOverlay = true;
          setTimeout(() => {
            this.errorOverlay = false;
          }, 3000);
        },
      });
    } else if (this.blDetails.operation_type_number === OperationType.CabotageImp) {
      this.loteCabotajeService.deleteCabotageImpBatch(this.infoLote.id, this.blDetails.operation_id)
      .subscribe({
        next: response => {
          if (response.error) {
            this.loading = false;
            this.loader = false;
            this.mensaje = 'No se puede eliminar lotes que tengan una operación registrada';
            this.icono = 'bi bi-exclamation-circle-fill';
            this.errorOverlay = true;
            setTimeout(() => {
              this.errorOverlay = false;
            }, 2000);
            return;
          }
          this.loteCabotajeService.getCabotageBatchesByShip(this.blDetails.operation_id)
          .subscribe({
            next: lotes => {
              this.loteService.lotes = [...lotes];
              this.loteService.lotesFilter = [...lotes];
              this.updateTotals(lotes, true);
              this.loader = false;
              this.loading = false;
              this.mensaje = 'Lote eliminado correctamente';
              this.icono = 'bi bi-check2';
              this.errorOverlay = true;
              setTimeout(() => {
                this.errorOverlay = false;
              }, 2000);
            },
            error: (e) => {
              this.showError('Error en el servidor al cargar los lotes, inténtelo más tarde', 3000);
            },
          });
        },
        error: (e) => {
          this.loading = false;
          this.loader = false;
          this.mensaje = 'Error en el servidor al eliminar el registro, inténtelo más tarde';
          this.icono = 'bi bi-exclamation-circle-fill';
          this.errorOverlay = true;
          setTimeout(() => {
            this.errorOverlay = false;
          }, 3000);
        },
      });
    }
  }

  /**
   * Recalcula los totales de la tabla (piezas, tonelajes de entrada, salida y
   * restante) a partir de la lista de lotes.
   * @param batches - Lista de lotes con la que se calculan los totales.
   * @param importBatches - `true` si los lotes son de importación/cabotaje importación.
   */
  updateTotals(batches: GetLote[], importBatches: boolean) {
    this.table_config.totals!.piezas = batches.reduce( (previous, current) => previous + Number(current.quantity_pieces), 0);
    this.table_config.totals!.total = batches.reduce( (previous, current) => previous + Number(current.input_tons), 0);
    if (importBatches) {
      this.table_config.totals!.total_output = batches.reduce( (previous, current) => previous + Number(current.output_tons), 0);
    } else {
      this.table_config.totals!.total_output = batches.reduce( (previous, current) => previous + Number(current.tonnage), 0);
    }
    this.table_config.totals!.total_remaining = batches.reduce( (previous, current) => previous + Number(current.remaining_tons), 0);
  }

  /**
   * Navega a la creación de un lote para el cliente indicado, validando el
   * permiso de creación según el tipo de operación.
   * @param clienteId - Identificador del cliente.
   * @param presentacionId - Identificador de la presentación del material.
   */
  addBatch(clienteId: number, presentacionId: number) {
    const isImportation = this.blDetails.operation_type_number === OperationType.Importation;
    const isCabotageImp = this.blDetails.operation_type_number === OperationType.CabotageImp;
    if (isImportation || isCabotageImp) {
      if ( this.auth.actions.create === false ) {
        this.isAuthorized = true;
        setTimeout(() => {
          this.isAuthorized = false;
        }, 3000);
        return;
      }
      if (isImportation) {
        this.router.navigate([`/ship-list/${this.operation_number}/importation/batch-create/${clienteId}`]);
      } else {
        this.router.navigate([`/ship-list/${this.operation_number}/cabotage/batch-create/${clienteId}`]);
      }
    } else {
      this.addLote = true;
      setTimeout(() => {
        this.addLote = false;
      },4000);
    }
  }

  downloadLayout() {
    this.loading = true;
    this.loteService.getUrlLayout()
    .subscribe({
      next: (response) => {
        this.loading = false;
        if (response.url) {
          window.open(response.url, '_blank');
        } else {
          this.mensaje = 'Error en el servidor al descargar el archivo, inténtelo más tarde';
          this.icono = 'bi bi-exclamation-circle-fill';
          this.errorOverlay = true;
          setTimeout(() => {
            this.errorOverlay = false;
          }, 3000);
        }
      },
      error: () => {
        this.loading = false;
        this.mensaje = 'Error en el servidor al descargar el archivo, inténtelo más tarde';
        this.icono = 'bi bi-exclamation-circle-fill';
        this.errorOverlay = true;
        setTimeout(() => {
          this.errorOverlay = false;
        }, 3000);
      }
    })
  }

  /**
   * Crea los lotes a partir de los datos cargados desde un archivo y recarga
   * la lista de lotes del barco.
   * @param data - Datos de los lotes a crear obtenidos del archivo.
   */
  onLoadFile(data: any) {
    data.operation_id = this.blDetails.operation_id;
    this.loading = true;
    this.loteService.createBatchList(data)
    .subscribe({
      next: (response) => {
        this.loading = false;
        if (response.error) {
          this.mensaje = response.message === 'Error tonnage excedied' ?
            'La suma de toneladas registradas es mayor a las del cliente' : response.message === 'Error invalid parameters' ?
            'La información no cuenta con el formato requerido' :
            'Error en el servidor al crear los lotes, inténtelo más tarde';
          this.icono = 'bi bi-exclamation-circle-fill';
          this.errorOverlay = true;
          setTimeout(() => {
            this.errorOverlay = false;
          }, 3000);
          return;
        }
        this.loader = true;
        this.loteService.getLotesBl(this.blDetails.operation_id)
        .subscribe({
          next: lotes => {
            if (!lotes.length) {
              this.loteService.lotes = [];
              this.loteService.lotesFilter = [];
              this.loading = false;
              this.loader = false;
              return;
            }
            const hasSupersacosBatch = lotes.some(batch => batch.material_group_id === 24);
            this.keyToSort = hasSupersacosBatch ? 'bl_lot_id' : 'registry_number';
            this.loteService.lotes = [...lotes];
            this.loteService.lotesFilter = [...lotes];
            this.updateTotals(lotes, true);
            this.loader = false;
            this.mensaje = 'Se han agregado los lotes correctamente';
            this.icono = 'bi bi-check2';
            this.errorOverlay = true;
            setTimeout(() => {
              this.errorOverlay = false;
            }, 2000);
          },
          error: (e) => {
            this.loader = false;
            this.mensaje = 'Error en el servidor al cargar los lotes, inténtelo más tarde';
            this.icono = 'bi bi-exclamation-circle-fill';
            this.errorOverlay = true;
            setTimeout(() => {
              this.errorOverlay = false;
            }, 3000);
          },
        });
      },
      error: () => {
        this.loading = false;
        this.mensaje = 'Error en el servidor al crear los lotes, inténtelo más tarde';
        this.icono = 'bi bi-exclamation-circle-fill';
        this.errorOverlay = true;
        setTimeout(() => {
          this.errorOverlay = false;
        }, 3000);
      }
    });
  }

  confirmDeleteAllBatches() {
    this.deleteBatchesOverlay = true;
  }

  /**
   * Elimina todos los lotes diferentes a granel del barco y recarga la lista,
   * o cancela la operación.
   * @param cancelar - Si tiene valor, cancela la eliminación masiva.
   */
  deleteAllBatches( cancelar: string ) {
    this.deleteBatchesOverlay = false;
    if ( cancelar ) {
      return;
    }
    this.loading = true;
    const batchIdList: number[] = [];
    this.lotesArray.forEach( (batch: any) => {
      if (batch.packing_id !== 1) {
        batchIdList.push(batch.registry_number);
      }
    });
    if (batchIdList.length === 0) {
      this.loading = false;
      this.mensaje = 'No hay lotes diferentes a granel para eliminar';
      this.icono = 'bi bi-info-circle-fill';
      this.errorOverlay = true;
      setTimeout(() => {
        this.errorOverlay = false;
      }, 2000);
      return;
    }
    this.loteService.deleteAllBatches(batchIdList).subscribe({
      next: (response) => {
        if (response.error) {
          this.loading = false;
          this.mensaje = response.message.includes('database') ?
            'No se puede eliminar lotes que tengan una operación registrada' :
            'Error en la base de datos al eliminar los lotes, inténtelo más tarde';
          this.icono = 'bi bi-exclamation-circle-fill';
          this.errorOverlay = true;
          setTimeout(() => {
            this.errorOverlay = false;
          }, 3000);
          return;
        }
        this.loader = true;
        this.loteService.getLotesBl(this.blDetails.operation_id)
        .subscribe({
          next: lotes => {
            if (!lotes.length) {
              this.loteService.lotes = [];
              this.loteService.lotesFilter = [];
              this.loading = false;
              this.loader = false;
              return;
            }
            const hasSupersacosBatch = lotes.some(batch => batch.material_group_id === 24);
            this.keyToSort = hasSupersacosBatch ? 'bl_lot_id' : 'registry_number';
            this.loteService.lotes = [...lotes];
            this.loteService.lotesFilter = [...lotes];
            this.updateTotals(lotes, true);
            this.loader = false;
            this.loading = false;
            this.mensaje = 'Lotes eliminados correctamente';
            this.icono = 'bi bi-check2';
            this.errorOverlay = true;
            setTimeout(() => {
              this.errorOverlay = false;
            }, 2000);
          }, error: (e) => {
            this.loader = false;
            this.mensaje = 'Error en el servidor al cargar los lotes, inténtelo más tarde';
            this.icono = 'bi bi-exclamation-circle-fill';
            this.errorOverlay = true;
            setTimeout(() => {
              this.errorOverlay = false;
            }, 3000);
          },
        });
      }, error: (e) => {
        this.loading = false;
        this.mensaje = 'Error en el servidor al eliminar los lotes, inténtelo más tarde';
        this.icono = 'bi bi-exclamation-circle-fill';
        this.errorOverlay = true;
        setTimeout(() => {
          this.errorOverlay = false;
        }, 3000);
      }
    });
  }

  checkImportationPieces() {
    this.isImportationPieces = this.clientesBl.some( client => client.id_presentation !== 1 && this.blDetails.operation_type === 'IMPORTACION' );
  }

  confirmUpdateShipBalance() {
    this.confirmUpdateShip = true;
    if (this.updateShipMessage === 'Saldar barco a ceros') {
      this.confirmUpdateShipMessage = '¿Está seguro de saldar el barco a ceros?';
    } else {
      this.confirmUpdateShipMessage = '¿Está seguro de regresar el saldo del barco?';
    }
  }

  /**
   * Confirma y aplica el saldo del barco (a ceros o regresándolo) y recarga
   * los datos del barco, o cancela la operación.
   * @param cancelar - Si tiene valor, cancela la actualización del saldo.
   */
  updateShipBalance( cancelar: string) {
    this.confirmUpdateShip = false;
    if (cancelar) {
      return;
    }
    const shipBalance = {
      ship_no: this.operation_number,
      status: this.updateShipMessage === 'Saldar barco a ceros' ? true : false
    };
    this.loading = true;
    this.blServices.updateShipBalance(shipBalance).subscribe({
      next: (response) => {
        if (response.error) {
          this.loading = false;
          this.mensaje = 'Error en el servidor, inténtelo más tarde';
          this.icono = 'bi bi-exclamation-circle-fill';
          this.errorOverlay = true;
          setTimeout(() => {
            this.errorOverlay = false;
          }, 3000);
          return;
        }
        this.blServices.getBlId(this.operation_number)
        .subscribe({
          next: blDetails => {
            if (!Array.isArray(blDetails) || !blDetails.length) {
              this.loading = false;
              this.overlayError = true;
              return;
            }
            this.blDetails = blDetails[0];
            this.loading = false;
            this.mensaje = this.updateShipMessage === 'Saldar barco a ceros' ? 'Saldo del barco actualizado a 0 correctamente' : 'Se regresó el saldo del barco correctamente';
            this.icono = 'bi bi-check2';
            this.updateShipBalanceText();
            this.errorOverlay = true;
            setTimeout(() => {
              this.errorOverlay = false;
            }, 2500);
          }
        })
      }, error: (e) => {
        this.loading = false;
        this.mensaje = 'Error en el servidor, inténtelo más tarde';
        this.icono = 'bi bi-exclamation-circle-fill';
        this.errorOverlay = true;
        setTimeout(() => {
          this.errorOverlay = false;
        }, 3000);
      }
    });
  }

  navigateToCustoms() {
    if (this.authService.hasAuthorization('export', 'customs', 'consult') === false) {
      this.isAuthorized = true;
      setTimeout(() => {
        this.isAuthorized = false;
      }, 3000);
      return;
    }
    this.router.navigate([`/ship-list/${this.operation_number}/exportation/petition`]);
  }

  /**
   * Ordena un arreglo por la clave indicada.
   * @param array - Arreglo a ordenar.
   * @param key - Clave del objeto por la que se ordena.
   * @returns El arreglo ordenado.
   */
  sortArray<T>(array: T[], key: keyof T): T[] {
    return array.sort(function (a, b) {
      if (b[key] < a[key]) {
        return -1;
      }
      if (b[key] > a[key]) {
        return 1;
      }
      return 0;
    });
  }

  /**
   * Ordena un arreglo por la clave indicada en orden inverso al de `sortArray`.
   * @param array - Arreglo a ordenar.
   * @param key - Clave del objeto por la que se ordena.
   * @returns El arreglo ordenado.
   */
  sortArrayDescending<T>(array: T[], key: keyof T): T[] {
    return array.sort(function (a, b) {
      if (b[key] > a[key]) {
        return -1;
      }
      if (b[key] < a[key]) {
        return 1;
      }
      return 0;
    });
  }

  exportConfigTable() {
    this.table_config.tableHeadsContainer = ['Detalle'];
    this.table_config.styles.container_icons = {
    'grid-template-columns': 'repeat(1, 1fr)',
    };
    this.table_config.iconos = [[`/ship-list/${this.operation_number}/importation/batch-detail`, "id_export_outputs", 'bi bi-eye']]
    this.table_config.tableHeads = [
      ['BL lote', 'bl_lot_id'],
      ['Nombre del lote', 'customer_lot_number'],
      ['Cliente', 'client_name'],
      ['Material', 'material_name'],
      ['Piezas', 'quantity_pieces'],
      ['Toneladas de salida', 'tonnage'],
    ];
    this.table_config.arrayFields = ['bl_lot_id', 'customer_lot_number', 'client_name', 'material_name', 'quantity_pieces', 'tonnage']
    this.table_config.styles.table_heads = {
      'grid-template-columns': 'repeat(6, minmax(90px, 1fr)) minmax(60px, 1fr)',
      'min-width': '600px',
      'margin': '0',
      'padding': '0',
    };
    this.table_config.styles.table_row = {
      'grid-template-columns': 'repeat(6, minmax(90px, 1fr)) minmax(60px, 1fr)',
      'min-width': '600px',
    };
    this.table_config.styles.table_row_totals = {
      'grid-template-columns': 'repeat(6, minmax(90px, 1fr)) minmax(60px, 1fr)',
      'min-width': '600px',
      'background-color': '#455660',
      'color': '#fff',
    }
    this.table_config.totals!.content = ['', '', '', 'Totales:', 'piezas', 'total_output'];
    if (this.loteService.loteExport && !this.showAfterJan2026) {
      this.table_config.tableHeads.push(['Estatus Pedimento', 'rectification']);
      this.table_config.arrayFields.push('rectification');
      this.table_config.styles.table_heads = {
        'grid-template-columns': 'repeat(7, minmax(90px, 1fr)) minmax(60px, 1fr)',
        'min-width': '690px',
        'margin': '0',
        'padding': '0',
      };
      this.table_config.styles.table_row = {
        'grid-template-columns': 'repeat(7, minmax(90px, 1fr)) minmax(60px, 1fr)',
        'min-width': '690px',
      };
      this.table_config.styles.table_row_totals = {
        'grid-template-columns': 'repeat(7, minmax(90px, 1fr)) minmax(60px, 1fr)',
        'min-width': '690px',
        'background-color': '#455660',
        'color': '#fff',
      };
      this.table_config.totals!.content = ['', '', '', 'Totales:', 'piezas', 'total_output', '',];
    }
  }

  cabotageConfigTable() {
    this.table_config = {
    tableHeads: [
        ['BL lote', 'bl_lot_id'],
        ['Cliente', 'client_name'],
        ['Material', 'material_group_name'],
        ['Piezas', 'quantity_pieces'],
        ['Toneladas de entrada', 'input_tons'],
        ['Toneladas de salida', 'output_tons'],
        ['Toneladas restantes', 'remaining_tons'],
      ],
      tableHeadsContainer: ['Entradas/ Salidas', 'Detalle', 'Editar', 'Eliminar'],
      styles: {
        table_heads: {
          'grid-template-columns': 'repeat(7, minmax(90px, 1fr)) 250px',
          'min-width': '880px',
          'margin': '0',
          'padding': '0',
        },
        table_row: {
          'grid-template-columns': 'repeat(7, minmax(90px, 1fr)) 250px',
          'min-width': '880px',
        },
        table_row_totals: {
          'grid-template-columns': 'repeat(7, minmax(90px, 1fr)) 250px',
          'min-width': '880px',
          'background-color': '#455660',
          'color': '#fff',
        },
        container_icons: {
          'grid-template-columns': 'repeat(4, 1fr)',
        }
      },
      arrayFields: [
        'bl_lot_id',
        'client_name',
        'material_group_name',
        'quantity_pieces',
        'input_tons',
        'output_tons',
        'remaining_tons',
      ],
      iconos: [
        [`/ship-list/${this.operation_number}/cabotage/batch-movement/entry`, "registry_number", 'bi bi-arrow-left-right'],
        [`/ship-list/${this.operation_number}/cabotage/batch-detail`, "registry_number", 'bi bi-eye'],
        [`/ship-list/${this.operation_number}/cabotage/batch-update`, "registry_number", 'bi bi-pencil-square'],
        ["/lote-eliminar", "registry_number", 'bi bi-trash3']
      ],
      mensaje: "Sin lotes asignados.",
      filter: true,
      totals: {
        show: true,
        content: ['', '', 'Totales:', 'piezas', 'total', 'total_output', 'total_remaining'],
        total: 0,
        total_output: 0,
        total_remaining: 0,
        piezas: 0
      }
    }
  }

  updateShipBalanceText() {
    this.updateShipMessage = this.blDetails.status_zero ? 'Regresar saldo del barco' : 'Saldar barco a ceros';
  }

  navigateToBill() {
    if (
      this.blDetails.operation_type_number === OperationType.Importation &&
      this.authService.hasAuthorization('import', 'billing', 'consult') === false
    ) {
      this.isAuthorized = true;
      setTimeout(() => {
        this.isAuthorized = false;
      }, 3000);
      return;
    }
    if (
      this.blDetails.operation_type_number === OperationType.Exportation &&
      this.authService.hasAuthorization('export', 'billing', 'consult') === false
    ) {
      this.isAuthorized = true;
      setTimeout(() => {
        this.isAuthorized = false;
      }, 3000);
      return;
    }
    if (
      (this.blDetails.operation_type_number === OperationType.CabotageImp || this.blDetails.operation_type_number === OperationType.CabotageExp) &&
      this.authService.hasAuthorization('cabotage', 'billing', 'consult') === false
    ) {
      this.isAuthorized = true;
      setTimeout(() => {
        this.isAuthorized = false;
      }, 3000);
      return;
    }
    this.router.navigate([`/ship-list/${this.operation_number}/bill/list`])
  }

  navigateToRule238() {
    this.router.navigate([`/ship-list/${this.operation_number}/rule238`])
  }

  /**
   * Muestra un overlay de error; con tiempo 0 muestra el overlay genérico,
   * de lo contrario muestra un mensaje temporal.
   * @param message - Mensaje de error a mostrar.
   * @param time - Tiempo en milisegundos antes de ocultar el mensaje (0 = overlay genérico).
   */
  showError(message: string = '', time: number = 0): void {
    this.loader = false;
    this.loading = false;
    if (time === 0) {
      this.overlayError = true;
      return;
    }
    this.mensaje = message;
    this.icono = 'bi bi-exclamation-circle-fill';
    this.errorOverlay = true;
    setTimeout(() => {
      this.errorOverlay = false;
    }, time);
  }
}
